"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEnrollment = exports.generateNewEnrollment = void 0;
const randexp_1 = require("randexp");
const faker_1 = __importDefault(require("faker"));
const generatePreEligibilityStep = (base = {}) => ({
    eligibleForMembership: undefined,
    ...base,
});
const generatePreCitizenshipStep = (base = {}) => ({
    birthCountry: '',
    birthLocality: '',
    birthSubdivision: '',
    citizenshipCountry: '',
    nonImmigrantVisaStatus: null,
    ...base,
});
const generatePreDocumentCheckStep = (base = {}) => ({
    photoId: '',
    document: null,
    ...base,
});
const generatePreBiographicInfoStep = (base = {}) => ({
    firstName: '',
    middleName: '',
    noMiddleName: false,
    lastName: '',
    suffix: '',
    gender: '',
    dateOfBirth: new Date(''),
    ...base,
});
const generatePreContactStep = (base = {}) => ({
    phoneNumber: '',
    email: '',
    emailVerification: '',
    preferredMethodOfContact: '',
    optIntoReceivingTexts: false,
    ...base,
});
const generatePreIdentityStep = (base = {}) => ({
    everUsedPreviousName: false,
    everUsedAlias: false,
    ...base,
});
const generatePreAttributesStep = (base = {}) => ({
    previousNames: [],
    aliases: [],
    eyeColor: '',
    hairColor: '',
    heightFeet: 0,
    heightInches: 0,
    weightPounds: 0,
    ...base,
});
const generatePreAddressesStep = (base = {}) => ({
    mailingAddress: {
        country: '',
        lineOne: '',
        locality: '',
        subdivision: '',
        postalCode: '',
    },
    useDifferentResidentialAddress: false,
    residentialAddress: {
        country: '',
        lineOne: '',
        locality: '',
        subdivision: '',
        postalCode: '',
    },
    atCurrentAddressMoreThanFiveYears: false,
    previousAddress: {
        country: '',
        lineOne: '',
        lineTwo: '',
        locality: '',
        subdivision: '',
        postalCode: '',
    },
    ...base,
});
const generatePreLegalQuestionnaireStep = (base = {}) => ({
    usCitizenOrNationalOrLPR: false,
    disqualifyingFelonyPartA: false,
    disqualifyingFelonyPartB: false,
    releasedFromIncarcerationPartB: false,
    wantedOrUnderIndictment: false,
    mentalCapacityLegalHistory: false,
    ...base,
});
const generatePreDocumentUploadStepCommand = (base = {}) => ({
    linkingDocExpectedCount: 0,
    uploadedFiles: [
        {
            fileName: '',
            nameLinking: false,
            documentType: '',
        },
        {
            fileName: '',
            nameLinking: true,
        },
    ],
    ...base,
});
const generatePreFinalizeStepCommand = (base = {}) => ({
    enrollmentLocationId: '',
    services: [
        {
            key: '',
            description: '',
            price: 0,
        },
        {
            key: '',
            description: '',
            price: 0,
        },
    ],
    price: 0,
    ...base,
});
const generatePlanSelection = (base = {}) => ({
    key: '',
    description: '',
    services: [],
    price: 0,
    ...base,
});
const generateAgreements = () => ({
    termsAndConditions: true,
    certifyAccurateData: true,
    promotionalMarketing: true,
    guardianAuthorization: true,
});
exports.generateNewEnrollment = () => ({
    id: faker_1.default.random.uuid(),
    applicationId: randexp_1.randexp('^[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{4}-[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{6}$'),
    agreement: generateAgreements(),
});
exports.generateEnrollment = (base = {}) => ({
    id: faker_1.default.random.uuid(),
    applicationId: randexp_1.randexp('^[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{4}-[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{6}$'),
    planSelection: generatePlanSelection(),
    eligibility: generatePreEligibilityStep(),
    citizenship: generatePreCitizenshipStep(),
    documentCheck: generatePreDocumentCheckStep(),
    biographicInfo: generatePreBiographicInfoStep(),
    contact: generatePreContactStep(),
    identityHints: generatePreIdentityStep(),
    attributes: generatePreAttributesStep(),
    addresses: generatePreAddressesStep(),
    legal: generatePreLegalQuestionnaireStep(),
    documents: generatePreDocumentUploadStepCommand(),
    finalized: generatePreFinalizeStepCommand(),
    agreements: generateAgreements(),
    ...base,
});
//# sourceMappingURL=generateEnrollment.js.map